import styles from "src/components/atoms/StatisticsItem/styles.module.css";
import cx from "classnames";
import React from "react";
import { CryptoCoin } from "../CryptoCoin";

export enum STATISTICSTYPE {
  SUCCESS = "success",
  ERROR = "error",
}

type Props = {
  type?: STATISTICSTYPE;
  img: string;
  title: string;
  value: string;
  symbol?: boolean;
};

export const StatisticsItem: React.FC<Props> = ({
  type,
  img,
  title,
  symbol,
  value,
}) => (
  <div
    className={cx(styles.wrapper, {
      [styles.success]: type === STATISTICSTYPE.SUCCESS,
      [styles.error]: type === STATISTICSTYPE.ERROR,
    })}
  >
    <div className={styles.img}>
      <img src={img} />
    </div>
    <div className={styles.info}>
      <h5>{title}</h5>
      <h3>
        {value}{" "}
        {symbol && (
          <CryptoCoin
            isBold
            fill={type === STATISTICSTYPE.SUCCESS ? "#27AE60" : "#FF4545"}
          />
        )}
      </h3>
    </div>
  </div>
);
